import { DesignSystem } from '@/src/design-system'

export function CardDeliveryBarSkeleton() {
  return (
    <DesignSystem.Skeleton.Skeleton
      style={{
        width: '100%',
        borderRadius: 16,
        height: 62,
        overflow: 'hidden',
      }}
    />
  )
}
